export const MODULE_NAME = 'sales';
export const ACCESS_NAME = 'Sales';
